/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
  useCuentaContableEmpresaCliente,
  useCuentaContableEmpresaProveedor,
} from "api/CuentaContableEmpresa.hook"
import { QUERY_PARAMETERS } from "common/constants"
import ContactosService from "common/services/ContactosService"
import FacturaService from "common/services/FacturaService"
import PagareService from "common/services/PagareService"
import notification from "common/utils/notification"
import mapContactosToTable from "features/Contactos/mappers/mapContactosToTable"
import { ESTADOS_VALIDACION } from "features/Validaciones/constants"
import i18next from "i18next"

export const getContacto = createAsyncThunk(
  "contacto/getById",
  async ({ id, handleGetContacto }: $TSMigrationFixMe) => {
    const { data } = await ContactosService.getById(id)
    handleGetContacto?.(data)
    return data
  }
)

export const getContactoAndEdit = createAsyncThunk(
  "contato/getAndEdit",
  async (id: $TSMigrationFixMe, { dispatch }: $TSMigrationFixMe) => {
    await dispatch(getContacto({ id }))
  }
)

export const fetchAllContactos = createAsyncThunk(
  "contactos/getAll",
  async () => {
    const { data } = await ContactosService.getAll()
    return data.items
  }
)

export const fetchContactosByFilters = createAsyncThunk(
  "contactos/getByFilters",
  async (_: $TSMigrationFixMe, { getState }: $TSMigrationFixMe) => {
    const { filters } = getState().contacto

    const { data } = await ContactosService.getContactosByFilters({
      queryState: filters,
    })

    return data
  }
)
export const fethContactosBySelectFilter = createAsyncThunk(
  "contactos/byFiltersSimple`",
  async (param: $TSMigrationFixMe, _: $TSMigrationFixMe) => {
    const { data } = await ContactosService.getContactosBySelectFilter({
      queryState: param,
    })
    return data
  }
)

export const createContacto = createAsyncThunk(
  "contacto/create",
  async (
    {
      contacto,
      refreshCuentaClientes,
      refreshCuentaProveedores,
      toggleIsContactCreatedDispatch,
    }: $TSMigrationFixMe,
    { dispatch, getState }: $TSMigrationFixMe
  ) => {
    try {
      const { data } = await ContactosService.post(contacto)
      const { isPaginationNedeed } = getState().contacto
      if (!isPaginationNedeed) {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        dispatch(fetchContactosByFilters())
        toggleIsContactCreatedDispatch()
        refreshCuentaClientes()
        refreshCuentaProveedores()
      }
      notification.success({
        body: `${i18next.t("notification.contactCorrectCreated")}`,
      })
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error al crear contacto:", error)
      throw error
    }
  }
)

export const editContacto = createAsyncThunk(
  "contacto/edit",
  async (
    contacto: $TSMigrationFixMe,
    { dispatch, getState }: $TSMigrationFixMe
  ) => {
    const { cuentasContablesEmpresasRefetch: refreshCuentaClientes } =
      useCuentaContableEmpresaCliente()
    const { cuentasContablesEmpresasRefetch: refreshCuentaProveedores } =
      useCuentaContableEmpresaProveedor()

    const { data } = await ContactosService.update(contacto)
    const { isPaginationNedeed } = getState().contactos
    if (!isPaginationNedeed) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      dispatch(fetchContactosByFilters())
      refreshCuentaClientes()
      refreshCuentaProveedores()
    }
    notification.success({
      body: `${i18next.t("notification.contactCorrectEdit")}`,
    })

    return data
  }
)

export const getContactoFacturaRecurrente = createAsyncThunk(
  "contacto/contacto/factura-recurrente",
  async (libradoRecurrente: $TSMigrationFixMe, _: $TSMigrationFixMe) => {
    const { data } = await ContactosService.getByContactoNif(
      libradoRecurrente.cif,
      libradoRecurrente.libradorId
    )

    return data
  }
)

export const hasContactoContactoPendingValidations = createAsyncThunk(
  "contacto/hasPengingValidations",
  async (empresaId: $TSMigrationFixMe) => {
    const query = `?${QUERY_PARAMETERS.Estados}=${ESTADOS_VALIDACION.AUTORIZACIONES.PENDIENTE}${QUERY_PARAMETERS.EmpresaId}=${empresaId}`
    const pendingValidations = await Promise.all([
      FacturaService.getFacturaAceptables(query),
      PagareService.getPagaresAceptables(query),
    ])

    return {
      hasPendingFacturas: !!pendingValidations[0].data?.totalCount,
      hasPendingPagares: !!pendingValidations[1].data?.totalCount,
    }
  }
)

const initialState = {
  contactos: [],
  allContactos: [],
  contactosBySelect: [],
  contacto: null,
  currentContacto: null,
  filters: {},
  totalCount: 0,
  fetchingContacto: false,
  fetchingContactos: false,
  fetchingAllContactos: false,
  creatingContacto: false,
  updatingContacto: false,
  showEditContactoModal: false,
  showCreateContactoModal: false,
  isContactCreated: false,
  fetchingContactosBySelect: false,
  isSelectFilterActive: true,
  isPaginationNedeed: false,
  cuentasBancarias: [],
  hasPendingFacturas: false,
  hasPendingPagares: false,
}

export const contactoSlice = createSlice({
  name: "contacto",
  initialState,
  reducers: {
    toggleShowEditContactoModal(state: $TSMigrationFixMe) {
      state.showEditContactoModal = !state.showEditContactoModal
    },
    toggleShowCreateContactoModal(state: $TSMigrationFixMe) {
      state.showCreateContactoModal = !state.showCreateContactoModal
    },
    toggleIsContactCreated(state: $TSMigrationFixMe) {
      state.isContactCreated = !state.isContactCreated
    },
    updateContactosFilters(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.filters = payload
    },
    clearContactoState() {
      return initialState
    },
    setIsSelectFilterActive(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.isSelectFilterActive = payload
    },
    setPaginationIsNeeded(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.isPaginationNedeed = payload
    },
    editCuentasBancarias(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.cuentasBancarias = payload
    },
    setContactoPendingValidaciones(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.hasPendingFacturas = payload.hasPendingFacturas
      state.hasPendingPagares = payload.hasPendingPagares
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContacto.pending, (state) => {
        state.fetchingContacto = true
      })
      .addCase(getContacto.rejected, (state) => {
        state.fetchingContacto = false
      })
      .addCase(
        getContacto.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.fetchingContacto = false
          state.contacto = payload
          state.cuentasBancarias = payload?.cuentasBancarias || []
        }
      )
      .addCase(fetchContactosByFilters.pending, (state) => {
        state.fetchingContactos = true
      })
      .addCase(fetchContactosByFilters.rejected, (state) => {
        state.fetchingContactos = false
      })
      .addCase(
        fetchContactosByFilters.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.fetchingContactos = false
          state.contactos = mapContactosToTable(payload?.items)
          state.totalCount = payload?.totalCount
        }
      )
      .addCase(fetchAllContactos.pending, (state) => {
        state.fetchingAllContactos = true
      })
      .addCase(fetchAllContactos.rejected, (state) => {
        state.fetchingAllContactos = false
      })
      .addCase(
        fetchAllContactos.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.fetchingAllContactos = false
          state.allContactos = payload
        }
      )
      .addCase(createContacto.pending, (state) => {
        state.creatingContacto = true
      })
      .addCase(createContacto.rejected, (state) => {
        state.creatingContacto = false
      })
      .addCase(
        createContacto.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.creatingContacto = false
          state.showCreateContactoModal = false
          state.isContactCreated = false
          state.allContactos = [payload, ...state.allContactos]
          state.contactosBySelect = [payload, ...state.contactosBySelect]
          state.currentContacto = payload
        }
      )
      .addCase(editContacto.pending, (state) => {
        state.updatingContacto = true
      })
      .addCase(editContacto.rejected, (state) => {
        state.updatingContacto = false
      })
      .addCase(
        editContacto.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.updatingContacto = false
          state.showEditContactoModal = false
          state.currentContacto = payload
        }
      )
      .addCase(getContactoAndEdit.fulfilled, (state) => {
        state.showEditContactoModal = true
      })
      .addCase(fethContactosBySelectFilter.pending, (state) => {
        state.fetchingContactosBySelect = true
      })
      .addCase(fethContactosBySelectFilter.rejected, (state) => {
        state.fetchingContactosBySelect = false
      })
      .addCase(
        fethContactosBySelectFilter.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.fetchingContactosBySelect = false
          const contactostoAdd = payload?.items
          const contactosBySelectCopy = state.contactosBySelect.slice()

          if (state.isSelectFilterActive) {
            state.contactosBySelect = contactostoAdd.length
              ? contactostoAdd
              : [{ razonSocial: "" }]
          } else {
            state.contactosBySelect = [
              ...contactosBySelectCopy,
              ...contactostoAdd,
            ]
          }
          state.totalCount = payload?.totalCount
        }
      )
      .addCase(getContactoFacturaRecurrente.pending, (state) => {
        state.fetchingContacto = true
      })
      .addCase(getContactoFacturaRecurrente.rejected, (state) => {
        state.fetchingContacto = false
      })
      .addCase(
        getContactoFacturaRecurrente.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.fetchingContacto = false
          state.contacto = payload
        }
      )
      .addCase(
        hasContactoContactoPendingValidations.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.hasPendingFacturas = payload.hasPendingFacturas
          state.hasPendingPagares = payload.hasPendingPagares
        }
      )
  },
})

export const {
  toggleShowCreateContactoModal,
  toggleShowEditContactoModal,
  toggleIsContactCreated,
  updateContactosFilters,
  clearContactoState,
  setIsSelectFilterActive,
  setPaginationIsNeeded,
  editCuentasBancarias,
} = contactoSlice.actions
